import { mapState, mapGetters, mapActions } from "vuex";

export const authComputed = {
    ...mapState("auth", {
        currentUser: (state) => state.currentUser,
    }),
    ...mapGetters("auth", ["loggedIn"]),
};

export const authMethods = mapActions("auth", ["logIn", "logOut", "register", "resetPassword"]);

export const layoutComputed = {
    ...mapState("layout", {
        layoutType: (state) => state.layoutType,
        leftSidebarType: (state) => state.leftSidebarType,
        layoutWidth: (state) => state.layoutWidth,
        topbar: (state) => state.topbar,
        loader: (state) => state.loader,
    }),
};

export const layoutMethods = mapActions("layout", [
    "changeLayoutType",
    "changeLayoutWidth",
    "changeLeftSidebarType",
    "changeTopbar",
    "changeLoaderValue",
]);

export const notificationMethods = mapActions("notification", ["success", "error", "clear"]);

export const adminComputed = {
    ...mapState("admin", {
        core: (state) => state.core,
        user_id: (state) => state.user_id,
        client_id: (state) => state.client_id,
        user_role: (state) => state.user_role,
        permissions: (state) => state.permissions,
        username: (state) => state.username,
        loggedIn_user_role: (state) => state.loggedIn_user_role,
        loggedIn_user_id: (state) => state.loggedIn_user_id,
        coreLoadingStatus: (state) => state.coreLoadingStatus,
        menu: (state) => state.menu,
    }),
    ...mapGetters("admin", ["getClientId", "getRole", "getValidUserRoute", "findPermission", "isTypeUser"]),
};

export const adminMethods = mapActions("admin", [
    "loadCoreData",
    "saveAddTeamMember",
    "saveEditTeamMember",
    "deleteTeamMember",
    "setCoreLoadingStatus",
    "menuBuilder",
]);

export const authFackMethods = {};

export const suppliersComputed = {
    ...mapState("suppliers", {
        suppliers_selected_client: (state) => state.suppliers_selected_client,
        selected_supplier_details: (state) => state.selected_supplier_details,
        client_suppliers: (state) => state.client_suppliers,
        supplier_certificates: (state) => state.supplier_certificates,
        suppliers_loading_status: (state) => state.suppliers_loading_status,
        selected_supplier_certificate: (state) => state.selected_supplier_certificate,
        agencies: (state) => state.agencies,
        searchFor_certificates_details: (state) => state.searchFor_certificates_details,
        result_of_searched_certificates: (state) => state.result_of_searched_certificates,
        selected_searched_certificate: (state) => state.selected_searched_certificate,
        suppliers_to_update: (state) => state.suppliers_to_update,
        suppliers_to_add: (state) => state.suppliers_to_add,
        supplier_name_heading: (state) => state.supplier_name_heading,
        suppliers_client_details: (state) => state.suppliers_client_details,
        teamMembersForCertificates: (state) => state.teamMembersForCertificates,
        teamManagersForCertificates: (state) => state.teamManagersForCertificates,
        qcUsersForCertificates: (state) => state.qcUsersForCertificates,
        suppliersToDeleteIds: (state) => state.suppliersToDeleteIds,
    }),
};

export const suppliersMethods = mapActions("suppliers", [
    "setSuppliersSelectedClient",
    "setSupplierDetails",
    "setSelectedCertificate",
    "searchForCertificatesDetails",
    "setSuppliers",
    "setSupplierCertificates",
    "setAgencies",
    "updateClientSupplierCertificateDetails",
    "updateActiveClientSupplierCertificate",
    // "updatecertificate",
    "deleteClientSupplierCertificate",
    "deleteBEECertificate",
    "searchCertificates",
    "setSearchForCertificatesDetails",
    "setSelectedSearchedCertificate",
    "duplicateClientSupplierCertificate",
    "saveClientSupplierCertificateDetails",
    "checkBeforeAddSuppliers",
    "resetAddSuppliersToEmpty",
    "saveAddUpdateSuppliers",
    "downloadCertificate",
    "setTeamMembersForCertificates",
    "shareCertificate",
    "setCertificateById",
    "addSuppliersToDeleteIds",
    "removeSuppliersToDeleteIds",
    "deleteClientSuppliers",
    "resetSuppliersToDeleteIds",
    "updateClientSupplier",
]);

export const clientsComputed = {
    ...mapState("clients", {
        clients: (state) => state.clients,
        client_loading_status: (state) => state.client_loading_status,
    }),
};

export const clientsMethods = mapActions("clients", ["setClients", "setClientsLoadingStatus"]);

export const collectionsListComputed = {
    ...mapState("collectionsList", {
        collectionsList: (state) => state.collectionsList,
        all_team_members: (state) => state.all_team_members,
        collectionlist_loading_status: (state) => state.collectionlist_loading_status,
    }),
};

export const collectionsListMethods = mapActions("collectionsList", [
    "setClientIdOfSuppliers",
    "setCollectionList",
    "deleteCollectionListRecord",
    "addClientToCollectionList",
    "assignTeamMembersToClient",
    "setTeamMembers",
    "setCollectionListLoadingStatus",
]);

export const certificateValidationComputed = {
    ...mapState("certificateValidation", {
        certificate_validation_questions: (state) => state.certificate_validation_questions,
        regulation_versions: (state) => state.regulation_versions,
        regulation_versions_transformed: (state) => state.regulation_versions_transformed,
        validation_checks: (state) => state.validation_checks,
        validation_checks_transformed: (state) => state.validation_checks_transformed,
        selected_regulation_version_details: (state) => state.selected_regulation_version_details,
        checks_by_regulation_version: (state) => state.checks_by_regulation_version,
        selected_check_details: (state) => state.selected_check_details,
        options_per_check: (state) => state.options_per_check,
        current_active_legislation: (state) => state.current_active_legislation,
        affidavit_checks_changed: (state) => state.affidavit_checks_changed,
        new_selected_legislation: (state) => state.new_selected_legislation,
        validation_checks_loading_status: (state) => state.validation_checks_loading_status,
    }),
};

export const certificateValidationMethods = mapActions("certificateValidation", [
    "setRegulationVersions",
    "setValidationChecksByCertificate",
    "setValidationChecksByRegulationVersion",
    "setSelectedRegulationVersionDetails",
    "setCheckOptions",
    "setSelectedCheckDetails",
    "setAffidavitChecksChanged",
    "saveCertificateValidationAnswer",
    "setActiveCertificateRegulationVersion",
    "setCurrentlActiveLegislation",
    "setNewSelectedLegislation",
    "saveCreateRegulationVersion",
    "saveCreateValidationCheck",
    "saveCreateValidationOption",
    "saveSetRegulationCheck",
    "setValiationChecksLoadinStatus",
    "saveAuthenticationProof",
]);

export const vettingComputed = {
    ...mapState("vetting", {
        // core: (state) => state.core,
        agency_certificates_for_vetting: (state) => state.agency_certificates_for_vetting,
        agency_info: (state) => state.agency_info,
        authentication_stats: (state) => state.authentication_stats,
        authentication_modal_data: (state) => state.authentication_modal_data,
        selected_certificate_for_authentication: (state) => state.selected_certificate_for_authentication,
    }),
};

export const vettingMethods = mapActions("vetting", [
    "setCertificatesForVetting",
    "sendCertificatesForVetting",
    "certificates_history",
    "setSelectedCertificateForAuthentication",
]);

export const userAdministrationComputed = {
    ...mapState("userAdministration", {
        // core: (state) => state.core,
        user_data: (state) => state.user_data,
        selected_user: (state) => state.selected_user,
        user_permissions: (state) => state.user_permissions,
        permissions_ids: (state) => state.permissions_ids,
    }),
};

export const userAdministrationMethods = mapActions("userAdministration", [
    "setSelectedUser",
    "setUsersForPermissions",
    "setUserPermissions",
    "saveUsersPermissions",
    "updatedPermissionsIds",
    "removePermissionsIds",
]);
